<template>
	<div class="dashboard">
		<EmployeeStudentDataForm
			:isSidebarActive="isShowStudentDataForm"
			@closeSidebar="toggleStudentDataForm"
			:data="data"
		/>
		<EmployeeStudentPointForm
			:isSidebarActive="isShowStudentPointForm"
			@closeSidebar="toggleStudentPointForm"
			:data="data"
		/>
		<div class="dashboard__left">
			<div class="score-summary">
				<h3 class="text-xl font-bold mb-1 md:mb-3">
					{{ $t('ProfileDormitory.Point') }}
					<i :title="$t('ProfileDormitory.ViewDetail')" class="nucleo nucleo-ic_info_24px cursor-pointer" @click="toggleStudentPointForm"></i>
				</h3>
				<table>
					<thead>
					<tr>
						<th class="text-base">{{ $t('ProfileDormitory.Semester') }}</th>
						<th class="text-base">{{ $t('ProfileDormitory.CoursePoint') }}</th>
						<th class="text-base">{{ $t('ProfileDormitory.SchoolTrainingPoint') }}</th>
						<th class="text-base">{{ $t('ProfileDormitory.DormitoryTrainingPoint') }}</th>
					</tr>
					</thead>
					<tbody v-if="sortedPoints.length > 0">
						<tr
							v-for="(item, index) in sortedPoints"
							:key="index"
						>
							<td :class="item.is_current ? 'text-solid-primary text-md font-black' : ''">HK{{ item.semester }}/Năm {{ item.school_year }}</td>
							<td>{{ item.course_point }}</td>
							<td>{{ item.school_training_point }}</td>
							<td>{{ item.dormitory_training_point }}</td>
						</tr>
					</tbody>
					<tbody v-else>
						<td colspan="4">{{ $t('NoData') }}</td>
					</tbody>
				</table>
			</div>

			<div v-if="sortedPoints.length > 0" class="chart">
				<ScoreChart :data="sortedPoints" />
			</div>
		</div>

		<div class="dashboard__right">
			<div v-if="hasStudentInfo" class="info">
				<div>
					<img
						v-if="data.avatar"
						class="info__avatar"
						:src="data.avatar"
						:alt="data.name"
					/>
					<vs-button class="info__toDetail" @click="toggleStudentDataForm">
						{{ $t('ProfileDormitory.ViewDetail') }}
					</vs-button>
				</div>
				<div class="info__item">
					<h3 class="info__heading">{{ data.name }}</h3>
					<div class="info__sub">
						{{ $store.state.AppActiveUser.role.code }}
					</div>
					<div class="info__sub">
						{{$t('ProfileDormitory.Course')}} {{ studentInfo.course }} |
						{{$t('ProfileDormitory.Room')}} {{ studentInfo.room }}
					</div>
				</div>
				<div class="info__item">
					<h3 class="info__heading">{{ studentInfo.school.name }}</h3>
					<div class="info__sub">
						{{ studentInfo.major }} |
						{{$t('ProfileDormitory.Faculty')}} {{ studentInfo.faculty }}
					</div>
				</div>
			</div>

			<div class="activity-log">
				<h3 class="text-xl font-bold mb-1 md:mb-3">{{ $t('ProfileDormitory.ActivityHistory') }}</h3>
				<div v-if="data.code">
					<ActivityHistory :personId="data.code" />
				</div>
				<div v-else>
					<p>{{ $t('NoData') }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import employeeGql from "@/http/requests/inside/employee_gql";
import moduleEmployee from "@/store/employee/moduleEmployee";
import moduleEvent from "@/store/event/moduleEvent";
import EmployeeStudentDataForm from "@/views/apps/cbs/employee/EmployeeStudentDataForm";
import EmployeeStudentPointForm from "@/views/apps/cbs/employee/EmployeeStudentPointForm";
import ScoreChart from "./ScoreChart";
import ActivityHistory from "./ActivityHistory";

export default {
	components: {
		ActivityHistory,
		EmployeeStudentDataForm,
		EmployeeStudentPointForm,
		ScoreChart,
	},
	data() {
		return {
			data: {},
			isShowStudentDataForm: false,
			isShowStudentPointForm: false,
			dates: [],
			activities: [],
		};
	},
	computed: {
		personalInfo() {
			try {
				return this.data.properties ? JSON.parse(this.data.properties).personal_info : {};
			} catch (error) {
				console.error('Error parsing personal info:', error);
				return {};
			}
		},
		studentInfo() {
			try {
				return this.data.properties ? JSON.parse(this.data.properties).student_info : {};
			} catch (error) {
				console.error('Error parsing student info:', error);
				return {};
			}
		},
		sortedPoints() {
			if (this.data && this.data.employee_points) {
				return [...this.data.employee_points].sort((a, b) => {
					return a.school_year === b.school_year ? a.semester - b.semester : a.school_year - b.school_year;
				});
			}
			return [];
		},
		hasStudentInfo() {
			return !!this.studentInfo && Object.keys(this.studentInfo).length > 0;
		},
	},
	methods: {
		getListEvents() {
			this.$store.dispatch("eventManagement/fetchEvents");
			this.$store.dispatch("eventManagement/fetchEventsViolation");
		},
		toggleStudentDataForm(val = false) {
			this.isShowStudentDataForm = !this.isShowStudentDataForm;
		},
		toggleStudentPointForm(val = false) {
			this.isShowStudentPointForm = !this.isShowStudentPointForm;
		},
	},

	async created() {
		this.$store.registerModule("employeeManagement", moduleEmployee);
		this.$store.registerModule("eventManagement", moduleEvent);
		try {
			if (this.$route.params.studentId) {
				const response = await employeeGql.getEmployee(this.$route.params.studentId);
				this.data = response.employee || {};
			}
		} catch (error) {
			console.error('Error fetching employee data:', error);
			this.data = {};
		}
		this.getListEvents();
	},
	beforeDestroy() {
		this.$store.unregisterModule("employeeManagement");
		this.$store.unregisterModule("eventManagement");
	}
};
</script>

<style lang="scss">
@import '~tailwindcss/base';
@import '~tailwindcss/components';
@import '~tailwindcss/utilities';
.dashboard {
	@apply flex flex-col-reverse;
	@screen md {
		@apply flex-row;
	}

	&__left {
		flex: 1 0 62.5%;
		margin-top: 25px;
		margin-right: 0;
		@screen md {
			margin-top: 0px;
			margin-right: 40px;
		}
	}

	&__right {
		flex: 1 0 100%;
		display: flex;
		flex-direction: column;
		gap: 10px;
		@screen md {
			flex: 1 0 385px;
			gap: 25px;
		}
		.info {
			display: flex;
			flex-direction: column;
			box-shadow: 0px 0px 4px 0px #00000040;
			border-radius: 10px;
			padding: 15px;
			gap: 12.5px;
			@screen md {
				padding: 30px;
				gap: 25px;
			}
			&__avatar {
				float: left;
				width: 80px;
				height: 80px;
				border-radius: 50%;
			}
			&__toDetail {
				float: right;
				margin-top: 20px;
				color: #fff;
			}
			&__item {
				display: flex;
				flex-direction: column;
				gap: 5px;
			}
			&__heading {
				@apply text-xl;
				font-weight: 600;
			}
		}

		.activity-log {
			display: flex;
			flex-direction: column;
			box-shadow: 0px 0px 4px 0px #00000040;
			border-radius: 10px;
			padding: 15px;
			@screen md {
				padding: 30px;
			}

			h2 {
				margin-bottom: 10px;
			}

			.activity-item {
				margin-bottom: 10px;

				&.info {
					color: blue;
				}

				&.warning {
					color: red;
				}
			}
		}
	}

	.calendar {
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;

		.date-item {
			padding: 10px;
			border-radius: 8px;
			text-align: center;
			background-color: #f0f0f0;

			&.highlight {
				background-color: #d8f5e1; // màu xanh nhạt
			}
		}
	}

	.score-summary {
		margin-bottom: 20px;

		table {
			width: 100%;
			border-collapse: collapse;

			th, td {
				border: 1px solid #ddd;
				padding: 8px;
				text-align: center;
			}

			th {
				background-color: #f4f4f4;
			}
		}
	}

	.student-info {
		background-color: #f9f9f9;
		padding: 20px;
		border-radius: 8px;
		margin-bottom: 20px;

		.gpa-info {
			display: flex;
			justify-content: space-between;
			margin-top: 10px;
		}

		button {
			margin-top: 10px;
			padding: 10px;
			background-color: #007bff;
			color: white;
			border: none;
			border-radius: 5px;
			cursor: pointer;

			&:hover {
				background-color: #0056b3;
			}
		}
	}
}
</style>
